import React from 'react';
import { Box, Stack, Text } from '@stitch-fix/mode-react';
import SizeGuideTable from '../../SizeGuideTable';
import './styles.module.scss';

/**
 * Size Comparison Component
 * Rendered as a tab in the SizeGuide, and only rendered if
 * businessLine === MENS
 */
const SizeComparison = () => {
  return (
    <Box data-testid="size-comparison-container">
      <Stack spacing={0.5} mb={0.5}>
        <Text height="standard" family="medium" scale="4">
          Find the best size for your height
        </Text>
        <Text height="tall" family="regular" scale="3">
          Use this chart to determine if you should pick a Standard, Short or
          Tall size. Applies to Tops only.
        </Text>
        <SizeGuideTable
          businessLine="MENS"
          sizeSchema="sizeComparison"
          tableName="default"
        />
      </Stack>
      <Box mb={3}>
        <Text height="short" family="medium" scale="2">
          SH
        </Text>{' '}
        <Text height="short" family="regular" scale="2">
          = Short |
        </Text>{' '}
        <Text height="short" family="medium" scale="2">
          TA
        </Text>{' '}
        <Text height="short" family="regular" scale="2">
          = Tall
        </Text>
      </Box>
      <Box mb={1}>
        <Text height="standard" family="medium" scale="4">
          Short/Tall garment considerations
        </Text>
      </Box>
      <Box styleName="comparison-description">
        <Stack spacing={0.5} mb={1}>
          <Text height="standard" family="medium" scale="3">
            Short sizes
          </Text>
          <Text height="tall" family="regular" scale="2">
            Compared to standard shirts, short-sized shirts are:
          </Text>
          <Stack as="ul" spacing={0}>
            <Text height="tall" family="regular" scale="2">
              1″ shorter in body length.
            </Text>
            <Text height="tall" family="regular" scale="2">
              0.5″ shorter in short sleeve length.
            </Text>
            <Text height="tall" family="regular" scale="2">
              1.5″ shorter in long sleeve length.
            </Text>
          </Stack>
          <Text height="tall" family="regular" scale="2">
            Compared to standard blazers, short-sized blazers are:
          </Text>
          <Stack as="ul" spacing={0}>
            <Text height="tall" family="regular" scale="2">
              1.5″ shorter in body length.
            </Text>
            <Text height="tall" family="regular" scale="2">
              0.5″ shorter in sleeve length.
            </Text>
          </Stack>
        </Stack>
        <Stack spacing={0.5} mb={1}>
          <Text height="standard" family="medium" scale="3">
            Tall sizes
          </Text>
          <Text height="tall" family="regular" scale="2">
            Compared to standard shirts, tall-sized shirts are:
          </Text>
          <Stack as="ul" spacing={0}>
            <Text height="tall" family="regular" scale="2">
              1″ longer in body length.
            </Text>
            <Text height="tall" family="regular" scale="2">
              0.25″ longer in short sleeve length.
            </Text>
            <Text height="tall" family="regular" scale="2">
              1.5″ longer in long sleeve length.
            </Text>
          </Stack>
          <Text height="tall" family="regular" scale="2">
            Compared to standard blazers, tall-sized blazers are:
          </Text>
          <Stack as="ul" spacing={0}>
            <Text height="tall" family="regular" scale="2">
              1″ longer in body length.
            </Text>
            <Text height="tall" family="regular" scale="2">
              1.5″ longer in sleeve length.
            </Text>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default SizeComparison;
